import React from "react";
import SkeletonElement from "./BasicSkeleton/SkeletonElement";
import SkeletonCard from "./BasicSkeleton/SkeletonCard";
import SkeletonAnimation from "./BasicSkeleton/SkeletonAnimation";

export default function StoriesSkeletonRow() {
  return (
    <>
      <div className="storyCard">
        <div className="info">
          <div>
            <div style={{ width: "120px", height: "20px" }}>
              <SkeletonElement type="box" />
            </div>
            <div style={{ width: "150px", height: "20px" }}>
              <SkeletonElement type="box" />
            </div>
          </div>
          <div className="d-flex">
            <div style={{ width: "20px", height: "20px" }}>
              <SkeletonElement type="box" />
            </div>
            <div style={{ width: "20px", height: "20px", marginRight: "10px" }}>
              <SkeletonElement type="box" />
            </div>
          </div>
        </div>
        <div className="body">
          <div style={{ width: "fill", height: "100px", marginRight: "10px" }}>
            <SkeletonElement type="box" />
          </div>{" "}
        </div>
      </div>
    </>
  );
}
